<template>
    <div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <slot name="header"></slot>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        userId: Number
    },
    data() {
        return {
            myModal: null
        }
    },
    beforeUnmount() {
        if (this.myModal) {
            this.myModal.dispose()
        }
    },
    methods: {
        show(message, onClickOkHandler) {
            this.message = message
            this.onClickOkHandler = onClickOkHandler

            this.toggle()
        },
        toggle() {
            if (this.myModal == null) {
                this.myModal = new window.bootstrap.Modal(this.$refs.modal)
            }
            this.myModal.toggle()
        }
    }
}
</script>